import React from "react";
import type { IconProps } from "./types";

/**
 * AiEditSparkIcon component that renders an AI edit (pencil + spark) icon SVG.
 * @param props - The component props
 * @param props.className - CSS class name for styling
 * @param props.width - Width of the icon (default: 12)
 * @param props.height - Height of the icon (default: 12)
 * @returns The rendered AI edit spark icon component
 */
const AiEditSparkIcon: React.FC<IconProps> = ({ className, width = 12, height = 12 }) => {
  return (
    <svg
      viewBox="-0.315 -0.315 15 15"
      xmlns="http://www.w3.org/2000/svg"
      id="Ai-Edit-Spark--Streamline-Ultimate"
      height={height}
      width={width}
      className={className}
      fill="none"
    >
      <desc>Ai Edit Spark Streamline Icon: https://streamlinehq.com</desc>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M0.6548828125 3.4622898375c1.3909980375000002 -0.2796342125 2.5109299750000003 -1.4131757375 2.7909893 -2.8401526625 0.2800653125 1.426976925 1.3997158375 2.56051845 2.7907078875 2.8401526625m0 0.0016226125c-1.3909920500000001 0.2796342125 -2.510918 1.4131757375 -2.7909833125 2.8401466749999997 -0.28005932499999997 -1.4269709375 -1.3997158375 -2.5605124625 -2.790713875 -2.8401466749999997"
        strokeWidth="0.63"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="m9.4978515 4.5607925125 2.7954440000000003 2.7954499874999996m-5.5076617500000005 5.4191665 -3.70422675 0.969017 0.9663286125 -3.7145252500000003L10.359931750000001 3.6963052875c0.751610875 -0.7536645875 1.986353125 -0.8074982 2.7916119999999998 0 0.751610875 0.7536645875 0.751610875 1.9918077375 0 2.7992939625L6.785633750000001 12.775409Z"
        strokeWidth="0.63"
      />
    </svg>
  );
};

export default AiEditSparkIcon;
